@if (showCartDropDown) {
    <a [matMenuTriggerFor]="menu" class="cart-link hidden-xs" data-test="header-cart">
        <span class="headerlink">
            <span class="headerlink__icon headerlink__icon--cart"></span>
            <span class="headerlink__text">Cart</span>
        </span>
        @if (total_quantity) {
            <span class="total-cart-count">{{ displayCartCount }}</span>
        }
    </a>
    <mat-menu #menu="matMenu" xPosition="before" [class]="total_quantity ? 'cart-menu-cont' : 'cart-menu-cont-empty'">
        @if (total_quantity) {
            <div class="cart-cont" (click)="$event.stopPropagation()">
                <app-multi-brand-cart-view [isCartDropdown]="showCartDropDown"></app-multi-brand-cart-view>
            </div>
            <div class="cart-footer col-sm-12 col-xs-12">
                <div class="item-row">
                    <div>
                        <span class="sub-total">Subtotal</span>
                    </div>
                    <div style="text-align: right">&#8377; {{ total_price }}</div>
                </div>
                <div class="text-center">
                    <button
                        data-test="proceed-to-cart"
                        btn-primary
                        size="full"
                        [isLoading]="submitCartInProgress"
                        (click)="submitCart()">
                        Checkout
                    </button>
                </div>
            </div>
        }
        @if (!total_quantity) {
            <div>Your cart is empty!</div>
        }
    </mat-menu>
}
